import { useForm } from '@/common/form/FormContext';
import { EntitySelect } from '@/common/form/formFields/EntitySelect'
import { ExprUtils } from '@/common/utils/ExprUtils';

export const ProdPriceProgSelect = ({ fieldDef }) => {

  const { formValues } = useForm();

  if (formValues.priceType !== 'MCD_EXT') {
    formValues.progId = null; // RESET
    return <></>;
  }

  // TODO: back end provided enums values
  fieldDef.expr = ExprUtils.whereParams('progType', ['MEDI', 'ADAP', 'SPAP', 'JCODE', 'SUPP', 'MM']);

  return <EntitySelect fieldDef={fieldDef}/>;
}